import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LottoPage from './pages/LottoPage';
import FortunePage from './pages/fortune/FortunePage';
import ZodiacPage from './pages/fortune/ZodiacPage';
import ChinesePage from './pages/fortune/ChinesePage';
import TarotPage from './pages/fortune/TarotPage';
import LuckyPage from './pages/fortune/LuckyPage';
import DreamPage from './pages/fortune/DreamPage';
import DreamCategoryPage from './pages/fortune/DreamCategoryPage';
import DreamSubjectPage from './pages/fortune/DreamSubjectPage';
import StatsPage from './pages/StatsPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import './styles/App.css';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Navigation />
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/lotto" element={<LottoPage />} />
          <Route path="/fortune" element={<FortunePage />} />
          <Route path="/fortune/zodiac" element={<ZodiacPage />} />
          <Route path="/fortune/chinese" element={<ChinesePage />} />
          <Route path="/fortune/tarot" element={<TarotPage />} />
          <Route path="/fortune/lucky" element={<LuckyPage />} />
          <Route path="/fortune/dream" element={<DreamPage />} />
          <Route path="/fortune/dream/:categoryId" element={<DreamCategoryPage />} />
          <Route path="/fortune/dream/:categoryId/:subjectId" element={<DreamSubjectPage />} />
          <Route path="/stats" element={<StatsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
